import { IsdurumkayitPage } from './../../Yonetim/isdurumkayit/isdurumkayit';
import { Component } from '@angular/core';
import {  NavController, NavParams, ModalController } from 'ionic-angular';
import { BllOrtak } from '../../../providers/bll/bll-ortak';
import { Ortak } from '../../../providers/ortak';

/**
 * Generated class for the IsdurumPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-isdurum',
  templateUrl: 'isdurum.html',
})
export class IsdurumPage {
  aranan="";
  skip:number=0;
  take:number=100;
  DurumListesi=[];


  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public modalCtrl:ModalController,

     public navParams: NavParams) {
  }

  ionViewDidLoad() {
   this.kayitAra(null);

  }
  kayitAra(e) {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "DurumListesi","", false).then(a => {
     
      var sonuc = <any>a;
      this.DurumListesi = sonuc.SonucObject;
     
   
 
    })
  }
  
  durumkayitlari(e) {

    if (e.keyCode == 13) {
      this.kayitAra(e);
    }
  }
  yenikayit() {
    let modal = this.modalCtrl.create(IsdurumkayitPage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  kayitduzenle(durum){
    let modal = this.modalCtrl.create(IsdurumkayitPage, { isVw: durum });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
    
  }
  DurumSil(durum) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("ID", durum.ID);

      this.bllOrtak.islem(formData, "DurumSil", "", true).then(a => {

      }).catch(x => {

        this.ortak.showErrorAlert();
      })
      this.kayitAra("");
     
    })
   
  }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/isdurum/isdurum.ts